// T4-251: Push to Salesforce is hidden for everyone until the feature is released. It is hard-coded, so no setting
// or feature flag can show it. Revert the T4-251 code commits (spec 061) to show it again.
export const isSalesforceQuotePushShown = (): boolean => false;
